var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "referral-page"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('components.main.navigation.referral-page'),
      "bordered": true
    }
  }), _vm._v(" "), _c('referral-hero-banner'), _vm._v(" "), _c('div', {
    staticClass: "d-grid gap-20 gap-sm-30 gap-lg-40 mt-20 mt-md-30 mt-lg-40"
  }, [_c('div', {
    staticClass: "px-20 px-md-30"
  }, [_c('referral-contents', {
    attrs: {
      "contents": _vm.referralContents
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "refer-now-and-instructions"
  }, [_c('div', {
    staticClass: "px-20 px-md-30"
  }, [_c('referral-step-instructions', {
    attrs: {
      "contents": _vm.stepByStepContents
    }
  }), _vm._v(" "), _c('refer-now-referral', {
    staticClass: "py-20 py-md-30 py-lg-40"
  })], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }